<template>
  <div>
    <!-- nav -->
    <div class="d-flex justify-space-between nav">
      <v-btn>
        <v-icon size="16">mdi-arrow-left</v-icon>
        返回
      </v-btn>
      <div class="text-h5 font-weight-medium">金豐小芋頭平台創業</div>
      <v-btn icon>
        <v-icon size="20">mdi-close</v-icon>
      </v-btn>
    </div>

    <v-container class="px-4 px-sm-6 py-6" style="max-width: 1062px !important">
      <!-- 實踐0元創業... -->
      <div class="gradient">
        <v-row class="d-flex flex-wrap-reverse">
          <v-col cols="12" sm="6" class="d-flex align-center justify-sm-center">
            <div class="text-left text-h4 blue--text text--accent-4 font-weight-bold">
              <div>實踐0元創業</div>
              <div>增加斜槓收入的人生</div>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <v-img :src="hand" contain max-width="442" class="w-100 mx-auto" style="height: auto"></v-img>
          </v-col>
        </v-row>
      </div>

      <!-- 成為代理人或介紹人... -->
      <div class="my-10 text-left">
        <div class="mb-4 text-h5 font-weight-bold">成為代理人或介紹人，賺取代理費用或介紹費用</div>
        <div>
          親愛的小芋頭會員您好：
          <br />
          現在您有機會在這個平台上創業成為代理人或介紹人，我們需要您分享或行銷推廣平台的【企業AI行銷會員】及【企業Al智庫會員】的商品。在AI時代來臨，企業如果沒有跟上AI的轉型，企業將面臨經營上競爭的困境。所以我們將好的商品推廣並分享給我們的朋友是很重要的。如果您的朋友因為您的推廣或分享而購買商品，我們將反饋您代理費用或介紹費用感謝您。現在您可以先決定您要不要成為平台的代理商或介紹人並完成繳費建立與平台的承攬合約。這是您創業或多一份斜槓收入的好機會。
        </div>
      </div>

      <div class="gradient-2">
        <!-- 01 -->
        <v-row>
          <v-col cols="12" sm="7" class="d-sm-flex align-center justify-start">
            <div class="upgrade-number mr-6 text-left">01</div>
            <div class="text-left">
              <div class="upgrade-text mb-2">創業成為代理人或介紹人</div>
              <div class="upgrade-sub">選擇小芋頭平台位階並填寫申請表</div>
            </div>
          </v-col>
          <v-col cols="12" sm="5">
            <v-img :src="upgrade_1" contain max-width="340" class="w-100 mx-auto" style="height: auto"></v-img>
          </v-col>
        </v-row>

        <!-- 02 -->
        <v-row class="d-flex flex-wrap-reverse">
          <v-col cols="12" sm="5">
            <v-img :src="upgrade_2" contain max-width="340" class="w-100 mx-auto" style="height: auto"></v-img>
          </v-col>
          <v-col cols="12" sm="7" class="d-sm-flex align-center justify-sm-center">
            <div class="upgrade-number mr-6 text-left">02</div>
            <div class="text-left">
              <div class="upgrade-text mb-2">
                <span class="indigo--text text--accent-4">分享</span>
                或
                <span class="indigo--text text--accent-4">行銷推廣</span>
                平台的【企業AI行銷會員】或【企業AI智庫會員】的商品
              </div>
              <div class="upgrade-sub">透過平台內的分享連結分享給顧客或好友</div>
            </div>
          </v-col>
        </v-row>

        <!-- 03 -->
        <v-row>
          <v-col cols="12" sm="7" class="d-sm-flex align-center justify-start">
            <div class="upgrade-number mr-6 text-left">03</div>
            <div class="text-left">
              <div class="upgrade-text mb-2">
                因為您的推廣或分享而
                <span class="indigo--text text--accent-4">購買商品</span>
              </div>
              <div class="upgrade-sub">顧客或好友購買【企業AI行銷會員】或【企業Al智庫會員】的商品成交後</div>
            </div>
          </v-col>
          <v-col cols="12" sm="5">
            <v-img :src="upgrade_3" contain max-width="340" class="w-100 mx-auto" style="height: auto"></v-img>
          </v-col>
        </v-row>

        <!-- 04 -->
        <v-row class="d-flex flex-wrap-reverse">
          <v-col cols="12" sm="5">
            <v-img :src="upgrade_4" contain max-width="340" class="w-100 mx-auto" style="height: auto"></v-img>
          </v-col>
          <v-col cols="12" sm="7" class="d-sm-flex align-center justify-end">
            <div class="upgrade-number mr-6 text-left">04</div>
            <div class="text-left">
              <div class="upgrade-text mb-2">
                <span class="indigo--text text--accent-4">獲得</span>
                代理費用或介紹費用
              </div>
              <div class="upgrade-sub">我們將反饋代理費用或介紹費用給您</div>
            </div>
          </v-col>
        </v-row>
      </div>

      <div class="my-10 bg-blue">
        <div class="mb-2 text-h5 font-weight-bold">小芋頭平台代理人或介紹人位階制度</div>
        <div>合約為期1年，合約一旦確認後，1年無法改變位階</div>
        <div class="my-6"></div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      hand: require("@/assets/image/upgrade/hand.svg"),
      upgrade_1: require("@/assets/image/upgrade/upgrade_1.svg"),
      upgrade_2: require("@/assets/image/upgrade/upgrade_2.svg"),
      upgrade_3: require("@/assets/image/upgrade/upgrade_3.svg"),
      upgrade_4: require("@/assets/image/upgrade/upgrade_4.svg"),
      pig: require("@/assets/image/upgrade/pig.svg"),
    };
  },
};
</script>

<style lang="scss" scoped>
.nav {
  height: 60px;
  padding: 16px var(--Spacing-8, 8px) var(--Spacing-8, 8px) var(--spacing-16, 16px);
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.gradient {
  padding: 24px;
  align-items: center;
  border-radius: 24px;
  background: linear-gradient(90deg, #ceeefe 0%, #d5fcb3 100%);

  @media (max-width: 375px) {
    padding: 24px 16px;
  }
}

.gradient-2 {
  padding: 80px;
  align-items: center;
  border-radius: 24px;
  background: linear-gradient(180deg, #dbf3ff 0%, #fff 100%);

  @media (max-width: 768px) {
    padding: 40px 24px;
  }

  @media (max-width: 375px) {
    padding: 40px 16px;
  }
}

.bg-blue {
  padding: 40px;
  border-radius: 24px;
  background: #e3f2fd;
  @media (max-width: 768px) {
    padding: 40px 24px;
  }

  @media (max-width: 375px) {
    padding: 40px 16px;
  }
}

.upgrade-number {
  color: var(--color-text-primary-87, rgba(0, 0, 0, 0.87));
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 72px */
}

.upgrade-text {
  color: var(--color-text-primary-87, rgba(0, 0, 0, 0.87));
  font-family: "Noto Sans TC";
  font-size: 28px;
  font-style: normal;
  font-weight: 900;
  line-height: 150%; /* 42px */
  letter-spacing: 0.25px;
  @media (max-width: 375px) {
    font-size: 25px;
  }
}

.upgrade-sub {
  color: var(--black-black-87, rgba(0, 0, 0, 0.87));
  font-family: "Noto Sans TC";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 27px */
  letter-spacing: 0.5px;
}
</style>
